module.exports = {
          srcSet: __webpack_public_path__ + "9615d837f268d1b68910427dc4ad5b69-66.jpg"+" 66w",
          images:[ {path: __webpack_public_path__ + "9615d837f268d1b68910427dc4ad5b69-66.jpg",width: 66,height: 66}],
          src: __webpack_public_path__ + "9615d837f268d1b68910427dc4ad5b69-66.jpg",
          toString:function(){return __webpack_public_path__ + "9615d837f268d1b68910427dc4ad5b69-66.jpg"},
          
          width: 66,
          height: 66
        }